@if (offlineOrder()) {
  <mat-icon class="icon" [class.conflict]="isConflicted()">article_person</mat-icon>
  <a
    lfwShouldOpenInNewTab
    [routerLink]="orderLink"
    class="doku"
    [attr.aria-describedby]="isConflicted() ? 'conflict-' + offlineOrder().form.order.id : null">
    <div class="bigtext ordertext" [class.conflict]="isConflicted()">
      {{ offlineOrder().form.order.text }}
      @if (isConflicted()) {
        <mat-icon class="conflict-icon" aria-hidden="true" [matTooltip]="'ORDERS.CONFLICT_TOOLTIP_OFFLINE' | translate"
          >info</mat-icon
        >
      }
    </div>
    <div class="states">
      @if (getOrderStateText(); as orderStateText) {
        <div class="text state small-text" [style]="getOrderStateStyle()">{{ orderStateText }}</div>
      }
      @if (getSubStateText(); as subStateText) {
        <div class="text state small-text" [style]="getSubStateStyle()">{{ subStateText }}</div>
      }
      @if (getScenarioText(); as scenarioText) {
        <div class="text state small-text" [style]="getScenarioStyle()">{{ scenarioText }}</div>
      }
    </div>
  </a>

  @if (isConflicted()) {
    <span [id]="'conflict-' + offlineOrder().form.order.id" class="visually-hidden">
      {{ 'ORDERS.CONFLICT_TOOLTIP_OFFLINE' | translate }}
    </span>
  }

  <div class="actions">
    @if (isOffline()) {
      <span [matTooltip]="'ORDERS.ACTION_TOOLTIP_NOT_POSSIBLE_WHILE_OFFLINE' | translate">
        <button mat-icon-button disabled>
          <mat-icon>cloud_upload</mat-icon>
        </button>
      </span>
    } @else {
      <button mat-icon-button [disabled]="isConflicted()" (click)="checkIn($event, offlineOrder().form.order.id)">
        <mat-icon>cloud_upload</mat-icon>
      </button>
    }

    @if (isOffline()) {
      <span [matTooltip]="'ORDERS.ACTION_TOOLTIP_NOT_POSSIBLE_WHILE_OFFLINE' | translate">
        <button mat-icon-button disabled>
          <mat-icon>delete</mat-icon>
        </button>
      </span>
    } @else {
      <button mat-icon-button (click)="discardOffline($event, offlineOrder().form.order.id)">
        <mat-icon>delete</mat-icon>
      </button>
    }
  </div>
}
